import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import React, { FC } from 'react';

interface TabLinks {
	name: string;
	path: string;
	display?: boolean | string;
}

type TableSelectionProps = {
	selection: string;
	tabNavLinks: TabLinks[];
};

export const TabNav: FC<TableSelectionProps> = (props) => {
	const { selection, tabNavLinks } = props;
	const theme: any = useTheme();

	return (
		<div className='tabNavSelections'>
			{tabNavLinks.map((link) => {
				const isActive = selection === link.path;

				return (
					<Link
						style={{
							...(isActive
								? {
										color: theme.tab?.color ?? 'white',
										backgroundColor: theme.tab?.backgroundColor ?? theme.sidebar.backgroundColor,
									}
								: {
										color: theme.text.color,
									}),
						}}
						className='tabNavSelection'
						key={link.name}
						href={link.path}
						target='_self'
					>
						{link.name}
					</Link>
				);
			})}
		</div>
	);
};
